import React, { useContext } from 'react';
import { Link } from 'react-router';
import { useSelector } from 'react-redux';

import { ShowComponentIfUserHasPermission } from 'RBAC/index';
import {
  StudioRoutes,
  BlossomRoutes,
  TowerHomeRoute,
  TenantAdminHomeRoute,
  TowerRoutes,
  DashboardAppsHomeRoute,
} from '../../../../../Routing/RouteConstants';
import { context } from '../../../../Theme/Context';
import MenuItem from './MenuItem';
import Logo from '../../../../../assets/images/logo-light.svg';
import envVariables from 'constants/react_env';
import { useGetStudioHomeRoute } from 'Routing/index';

const navLinkClasses =
  'ph3 w-100 no-underline white pointer fs-18 lh-21 flex items-center bb b--black-pearl menu-item';
const PodAdminPermissions = BlossomRoutes.podManagement.permission;
const StudioPermissionsRead = StudioRoutes.permissions;

const StudioPermissionsEdit = [
  ['models', 'model', 'c'],
  ['queries', 'query', 'c'],
  ['apis', 'api', 'c'],
];

function MenuItemsTop({ closeMenu }) {
  const theme = useContext(context);
  const currentUser = useSelector((state) => state.users.currentUser);

  const StudioPath = useGetStudioHomeRoute();

  return (
    <div onClick={closeMenu}>
      <Link
        to="/"
        className={navLinkClasses + ' pa0 bg-black-pearl logo'}
        style={{
          height: 87,
        }}
      >
        {theme.useCustomTheme && !theme.logos.useDefaultNavbarLogo && (
          <img
            alt="navbar logo"
            src={theme.logos.navbar}
            className="cover"
            style={{
              width: '100%',
              height: '100%',
              maxHeight: 50,
            }}
          />
        )}
        {(!theme.useCustomTheme || theme.logos.useDefaultNavbarLogo) && (
          <img
            src={Logo}
            style={{
              height: 40,
              width: 119,
            }}
            className="cover"
            alt="logo"
          />
        )}
      </Link>

      {/* pod-admin link */}
      <ShowComponentIfUserHasPermission permissionRef={PodAdminPermissions} allowAny={true}>
        <MenuItem
          className={navLinkClasses}
          to={`/${BlossomRoutes.podManagement.base}/${BlossomRoutes.podManagement.security.base}`}
          data-testid="pod-config-link"
          text={'Pod Configuration'}
          segment={BlossomRoutes.podManagement.base}
        />
      </ShowComponentIfUserHasPermission>

      <ShowComponentIfUserHasPermission allowAny={true} permissionRef={StudioPermissionsRead}>
        <MenuItem
          className={navLinkClasses + ' studio-link'}
          to={StudioPath}
          data-testid="studio-app-link"
          text="Decision Studio"
          segment={StudioRoutes.base}
        />

        <ShowComponentIfUserHasPermission permissionRef={StudioPermissionsEdit}>
          <MenuItem
            className={navLinkClasses + ' fw3 sub-menu-item i audit-log-link'}
            to={`/${StudioRoutes.base}/${StudioRoutes.auditLog.base}`}
            data-testid="audit-log-link"
            text="Audit Log"
            segment={StudioRoutes.auditLog.base}
          />
        </ShowComponentIfUserHasPermission>

        <MenuItem
          className={navLinkClasses + ' bb-0'}
          to={TowerHomeRoute}
          data-testid="tower360-app-link"
          text={envVariables.towerTitle}
          segment={TowerRoutes.base}
        />

        {currentUser?.showDashboardApps && (
          <MenuItem
            className={navLinkClasses + ' bb-0'}
            to={`/${DashboardAppsHomeRoute}`}
            data-testid="dashboard-apps-link"
            text="Apps"
            segment={BlossomRoutes.dashboardApps.base}
          />
        )}
      </ShowComponentIfUserHasPermission>

      <ShowComponentIfUserHasPermission permissionRef={BlossomRoutes.tenantAdmin.user.permissions}>
        <div
          style={{
            height: 24,
            backgroundColor: 'rgba(24,32,39,0.5)',
          }}
        ></div>
        <MenuItem
          data-testid="users-link"
          to={TenantAdminHomeRoute}
          className={navLinkClasses + ' bn'}
          text="Tenant Admin"
          segment={BlossomRoutes.tenantAdmin.base}
        />
      </ShowComponentIfUserHasPermission>
    </div>
  );
}

export default MenuItemsTop;
